module.exports = __webpack_public_path__ + "static/media/person1.4baea0c3.png";